<template>
  <div class="queue-telatv">
    <p class="queue-telatv__station-name">{{ station.name }}</p>
    <div class="queue-telatv__side queue-telatv__side--preferencial">
      <h2 class="queue-telatv__title">Fila Preferencial</h2>
      <p class="queue-telatv__number">{{ CurrentClientePreferencial }}</p>
    </div>
    <div class="queue-telatv__side">
      <h2 class="queue-telatv__title">Fila Normal</h2>
      <p class="queue-telatv__number">{{ CurrentClienteNormal }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import socket from '../../socket/index.js'

export default {
  name: 'QueueTelatv',
  computed: {
    ...mapGetters(['station', 'CurrentClienteNormal', 'CurrentClientePreferencial'])
  },
  async created () {
    await this.fetchStation({
      accountName: this.$route.params.account,
      stationName: this.$route.params.station
    })

    socket.emit('joinStation', this.station.id)
    socket.on('stationUpdated', this.handleStationUpdated)
  },
  beforeUnmount () {
    socket.off('stationUpdated', this.handleStationUpdated)
  },
  methods: {
    ...mapActions(['fetchStation']),
    handleStationUpdated (station) {
      this.$store.commit('SET_STATION', station)
    }
  }
}
</script>

<style scoped>
.queue-telatv {
  position: relative;
  display: flex;
  min-height: 100vh;
}

.queue-telatv__station-name {
  position: absolute;
  top: 16px;
  right: 16px;
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
}

.queue-telatv__side {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.queue-telatv__side--preferencial {
  color: red;
}

.queue-telatv__title {
  font-size: 3rem;
  margin: 0;
}

.queue-telatv__number {
  font-size: 10rem;
  font-weight: bold;
  margin: 0;
}
</style>
